import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useHtmlLang = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        const lang = i18n.language === 'ru' ? 'ru' : 'en';
        document.documentElement.lang = lang;
    }, [i18n.language]);
};
